import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './ServiceBar.module.css';

const MARQUEE_ITEMS = [
  { label: 'VISION', desc: 'Raise the Remnant. Carry the Fire. Reveal Christ.', link: '/missionandvision' },
  { label: 'MISSION', desc: 'Reach. Restore. Raise. Release. Revive. Send.', link: '/missionandvision' },
  { label: 'WEEKLY WORSHIP', desc: 'Fridays 8:15 PM – 10:15 PM • Old Main Hall, Ruwi', link: '/eventscalendar' },
  { label: 'LAMBS (CHILDREN)', desc: 'Fridays 6:00 PM – 7:30 PM • Children’s Church', link: '/lambs' },
  { label: 'SEEKING HIS FACE', desc: 'Daily Morning Prayer at 4:00 AM GST', link: '/eventscalendar' },
  { label: 'CELL FELLOWSHIP', desc: 'Thursdays 8:00 PM (1st & 2nd Thu)', link: '/eventscalendar' },
  { label: 'NIGHT VIGILANCE', desc: '9:30 PM – 3:00 AM (3rd Thursday of the Month)', link: '/eventscalendar' },
  { label: 'FASTING PRAYER', desc: '8:00 PM (Last Wednesday & Thursday of the Month)', link: '/eventscalendar' },
  { label: 'LION CUBS (YOUTH)', desc: 'Saturdays • Youth Ministry Meetings', link: '/young-lion-cubs' },
];

export default function ServiceBar() {
  const renderLoop = key => {
    const isClone = key === 'clone';
    return (
      <div className={styles.track} key={key} aria-hidden={isClone}>
        {MARQUEE_ITEMS.map((item, idx) => (
          <NavLink
            to={item.link || '/eventscalendar'}
            key={idx}
            className={styles.marqueeItem}
            tabIndex={isClone ? -1 : undefined}
          >
            <span className={styles.sparkle}>✦</span>
            <strong className={styles.itemTag}>{item.label}</strong>
            <span className={styles.itemDesc}>{item.desc}</span>
          </NavLink>
        ))}
      </div>
    );
  };

  return (
    <div className={styles.bar}>
      <div className={styles.marqueeWrapper}>
        {renderLoop('original')}
        {renderLoop('clone')}
      </div>
    </div>
  );
}
